import { sectionAlignStatus } from "components/TemplateEditor/Functions";

/**
 * @description - Function for handle section drag events
 * @param event - Drag event
 * @param sectionId - Selected section ID
 */
export const dragMoveListener = (event, sectionId) => {
  try {
    const pageId = `page_${sectionId?.substring(0, 1)}`;

    if (event && event.target) {
      const { isSnappedXDirection, isSnappedYDirection } = sectionAlignStatus(
        pageId,
        sectionId,
        event
      );

      var target = event.target;
      let sectionXPosition = event.dx;
      let sectionYPosition = event.dy;

      if (isSnappedXDirection) {
        sectionXPosition = 0;
      }
      if (isSnappedYDirection) {
        sectionYPosition = 0;
      }

      // keep the dragged position in the data-x/data-y attributes
      var x =
        (parseFloat(target.getAttribute("data-x")) || 0) + sectionXPosition;
      var y =
        (parseFloat(target.getAttribute("data-y")) || 0) + sectionYPosition;

      // translate the element
      target.style.transform = "translate(" + x + "px, " + y + "px)";

      // update the posiion attributes
      target.setAttribute("data-x", x);
      target.setAttribute("data-y", y);
    }
  } catch (error) {
    console.error("dragMoveListener error : ", error);
  }
};

// handle paste plain text from somewhere else
export const pasteAsPlainText = (event) => {
  try {
    event.preventDefault();

    const text = event.clipboardData.getData("text/plain");
    document.execCommand("insertHTML", false, text);
  } catch (error) {
    console.log("pasteAsPlainText failed : ", error);
  }
};
